import cn from 'classnames'
import { useEffect, useRef } from 'react'

import styles from './Spiral.module.scss'

type AnimationVariant = 'appear' | 'rotate'

type Props = {
  isAnimated?: boolean
  src: string
  animationVariant?: AnimationVariant
  shouldPlay?: boolean
}

export const Spiral = ({
  isAnimated,
  src,
  animationVariant = 'rotate',
  shouldPlay = true,
}: Props) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (!videoRef.current) return
    if (shouldPlay) {
      videoRef.current.play().catch(() => {})
    } else {
      videoRef.current.pause()
      videoRef.current.currentTime = 0
    }
  }, [shouldPlay, src])

  return (
    <div
      className={cn([
        styles.spiral,
        styles[animationVariant],
        isAnimated && styles[`${animationVariant}Animated`],
        shouldPlay && styles.spiral__isActive,
      ])}
    >
      <div
        className={cn(styles.spiralBg, {
          [styles.spiralBg__rotate]: animationVariant === 'rotate',
        })}
      >
        <video
          ref={videoRef}
          src={src}
          className={styles.lottieAnimation}
          loop
          autoPlay={shouldPlay}
          muted
          playsInline
        />
      </div>
    </div>
  )
}
